import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	template: '',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class EmptyComponent {}
